import React, { Component } from 'react';
import { connect } from 'react-redux';

import Embed from './components/Embed';

import { getSnippet } from '../../store/actions/embed';


class EmbedContainer extends Component {
    componentDidMount() {
        if (!this.props.snippet) {
            const { snippetId } = this.props.match.params;
            this.props.fetchSnippet(snippetId);
        }
    }

    render() {
        return (
            this.props.snippet ? <Embed {...this.props} /> : null
        );
    }
}

export default connect(
    ({ embed }) => ({
        snippet: embed.snippet,
    }),
    dispatch => ({
        fetchSnippet: id => dispatch(getSnippet(id)),
    })
)(EmbedContainer);
